import type { AITextAgent } from '@app/services/text-agent.types';
import {
    Descriptions,
    Drawer,
    Tabs,
    type DescriptionsProps,
    type DrawerProps,
    type TabsProps,
} from 'antd';
import { StyledTag } from '@app/components/tag/Tag';
import ReactMarkdown from 'react-markdown';
import { useState } from 'react';

export type TextAgentDrawerProps = DrawerProps & {
    data: AITextAgent | null;
};

export const TextAgentDrawer = ({ data, ...props }: TextAgentDrawerProps) => {
    const [activeTab, setActiveTab] = useState<string>('1');

    const detailsItems: DescriptionsProps['items'] = [
        {
            key: '1',
            label: 'Agent Name',
            children: data?.name || '-',
        },
        {
            key: '2',
            label: 'Model',
            children: data?.model_name || '-',
        },
        {
            key: '3',
            label: 'Logo',
            children: data?.logo ? (
                <img src={data?.logo} alt="Logo" className="logo" />
            ) : (
                <StyledTag style={{ marginTop: 5 }}>Not Set</StyledTag>
            ),
        },
    ];

    const renderDetailsTab = () => {
        return (
            <Descriptions
                title="Details"
                colon={false}
                layout="vertical"
                items={detailsItems}
                column={2}
            />
        );
    };

    const renderPromptTab = () => {
        return (
            <Descriptions
                colon={false}
                layout="vertical"
                items={[
                    {
                        key: '1',
                        children: (
                            <div className="markdown-body">
                                <ReactMarkdown>{data?.system_prompt || '-'}</ReactMarkdown>
                            </div>
                        ),
                    },
                ]}
            />
        );
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Details',
            children: renderDetailsTab(),
        },
        {
            key: '2',
            label: 'Prompt',
            children: renderPromptTab(),
        },
    ];

    return (
        <Drawer
            title={
                <>
                    <span>AI Text Agent Details</span>
                    {data?.id ? (
                        <div className="ant-drawer-header-meta">
                            <span>ID: {data?.id}</span>
                        </div>
                    ) : null}
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            afterOpenChange={() => {
                if (!props.open) {
                    setActiveTab('1');
                }
            }}
            {...props}>
            <Tabs
                items={items}
                activeKey={activeTab}
                onChange={(key) => setActiveTab(key)}
                className="sticky-tabs"
            />
        </Drawer>
    );
};

export default TextAgentDrawer;
